<!--
  ~ Copyright (c) 2020. Sayari LLC
  -->

<!-- Navigation -->
<div id="wrapper">
    <!-- Navigation -->
    <nav class="navbar navbar-inverse navbar-fixed-top nav-bar-color" role="navigation">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
            <a class="logo-font" href="/">speckles</a>
        </div>
        <div id="logout-link">
            <!--<button type="button" class="btn btn-default navbar-btn login-button">Log out</button>-->
            <a href="/login" class="login-button" style="color: #ffffff;">Log Out</a>
        </div>

        <!-- /.navbar-collapse -->
    </nav>
</div>